import React from "react";
import styles from "./Balance.module.css";
import classNames from "classnames";
import locale from "./Balance.locale";
export default function Balance({ balance }) {
    if (!balance) {
        return React.createElement("div", null);
    }
    return (React.createElement("div", { className: classNames(styles.card, balance.sign === "-" && styles.negative) },
        React.createElement("h2", { className: styles.title, title: locale.TITLE }, locale.TITLE),
        React.createElement("div", { className: styles.content },
            React.createElement("div", { className: styles["icon-container"] },
                React.createElement("i", { className: classNames(styles.icon, "icon-outline-credit-card") })),
            React.createElement("div", { className: styles["balance-container"], title: `${balance.full}${locale.CURRENCY}` },
                React.createElement("span", { className: classNames(styles.integer, "text-overflow-ellipsis") },
                    balance.sign,
                    balance.integer),
                balance.fractional && (React.createElement("span", { className: classNames(styles.fractional, "text-overflow-ellipsis") },
                    balance.decimalSeparator,
                    balance.fractional)),
                React.createElement("span", { className: styles.currency }, locale.CURRENCY)))));
}
